import React, {useState} from 'react';

import {
  useCurrentUserState,
  useUpdateUserTourStatus,
} from 'app/current-user/api';
import {CheckboxField} from 'app/general/widgets/CheckboxField';
import {gt} from 'app/utils/i18n';

export function Tour() {
  const {tours} = useCurrentUserState().data!;
  const [isShowingTour, setIsShowingTour] = useState(
    () =>
      !Object.values(tours).some(
        (tour) => tour.status === 'finished' || tour.status === 'cancelled'
      )
  );

  const [updateTour, {isLoading}] = useUpdateUserTourStatus();

  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setIsShowingTour(e.target.checked);
    updateTour({tourname: '*', status: e.target.checked ? 1 : 0})
      .unwrap()
      .catch(() => {
        setIsShowingTour(!e.target.checked);
      });
  };

  return (
    <div className="pt-4 form">
      <h4 className="pb-2 border-bottom">{gt('SweetProcess Tour')}</h4>
      <CheckboxField
        label={gt('Show the SweetProcess Tour?')}
        disabled={isLoading}
        name="tour"
        id="id_tour"
        onChange={handleCheckboxChange}
        value={isShowingTour}
      />
    </div>
  );
}
